export function ReadMoreIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M4.96536 11.6329L4.03203 10.6995L6.0487 8.66621H1.33203V7.33288H6.0487L4.03203 5.29954L4.96536 4.36621L8.5987 7.99954L4.96536 11.6329ZM8.66536 11.3329V9.99954H14.6654V11.3329H8.66536ZM8.66536 5.99954V4.66621H14.6654V5.99954H8.66536ZM10.6654 8.66621V7.33288H14.6654V8.66621H10.6654Z'
        fill='currentColor'
      />
    </svg>
  )
}
